import { render, staticRenderFns } from "./AccountSettingPreferences.vue?vue&type=template&id=0969523c&"
import script from "./AccountSettingPreferences.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPreferences.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingPreferences.vue?vue&type=style&index=0&id=0969523c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports